import _ from 'lodash';

const humanize = (secs) =>
    _.reduce([[60, 'seconds'], [60, 'minutes'], [24, 'hours'], [1000, 'days']], (s, [count, name]) => {
        if (secs > 0) {
            let n = secs % count | 0;
            secs = secs / count | 0;
            if (n < 10) {
                n = `0${n}`;
            }
            s.unshift(n);
        }
        return s;
    }, []).join(':');

$(() => {
    const el = $('[data-remaining]')[0];
    if (el) {
        const $el = $(el);
        let remaining = parseInt($el.data('remaining')) * 1000;
        if (!Number.isNaN(remaining)) {
            setInterval(() => {
                const r = (remaining - Date.now()) / 1000;
                let text = humanize(r);
                if (_.isEmpty(text)) {
                    text = '-';
                }
                $el.text(text);
            }, 1000);
        }
    }
});